// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YwxTH","left":"styles_left__pCGS-","right":"styles_right__2y3Dx","alert":"styles_alert__2XuDI"};